const bannerExpert = require("@/assets/img/ExpertThinkTank.png");
const bannerInfoBase = require("@/assets/img/infobase_banner.png");
const bannerAbout = require("@/assets/img/about-bg2.png");
const newsCover = require("@/assets/img/new-1.png");
const noticeCover = require("@/assets/img/article-img.png");
const activityCover = require("@/assets/img/active-img.png");
const expertAvatar1 = require("@/assets/img/task-1.png");
const expertAvatar2 = require("@/assets/img/task-2.png");
const expertAvatar3 = require("@/assets/img/task-3.png");
const expertAvatar4 = require("@/assets/img/task-4.png");
const expertAvatar5 = require("@/assets/img/task-5.png");
const publicationCover = require("@/assets/img/expert-1.png");
const timelineCover1 = require("@/assets/img/box-display-1.png");
const timelineCover2 = require("@/assets/img/active-1.png");
const timelineCover3 = require("@/assets/img/active-2.png");

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function createResult(data, extra = {}) {
  return Promise.resolve({
    status: 200,
    success: true,
    msg: null,
    data: clone(data),
    ...extra,
  });
}

function stripHtml(html = "") {
  return html.replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim();
}

function formatDate(value) {
  if (!value) return "";
  if (typeof value === "string" && value.length >= 10) {
    return value.slice(0, 10);
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value).slice(0, 10);
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function buildNewsContent(title, paragraphs) {
  const body = paragraphs.map((item) => `<p>${item}</p>`).join("");
  return `<h3>${title}</h3>${body}`;
}

const newsRecords = [
  {
    id: 101,
    classify: 1,
    title: "艺科美课启动年度工艺美术课程共建计划",
    summary: "围绕传统工艺、材料创新与数字传播，平台联合院校持续推进课程共建。",
    image: newsCover,
    source: "艺科美课",
    releaseDate: "2026-03-18 10:00:00",
    createTime: "2026-03-18 10:00:00",
    content: buildNewsContent("艺科美课启动年度工艺美术课程共建计划", [
      "平台将围绕课程资源整合、校企协同实践与成果展示三个方向，持续补充官网公开内容。",
      "新版官网改造后，资讯栏目将优先展示与当前后端能力一致的内容，保证页面访问稳定。",
      "后续如恢复原资讯后台，也可以继续沿用当前页面结构平滑接回动态数据。",
    ]),
  },
  {
    id: 102,
    classify: 1,
    title: "全国高校工艺美术优秀作品征集持续进行中",
    summary: "聚焦毕业季、青年创作者与跨学科创新，平台持续开放线上展示入口。",
    image: noticeCover,
    source: "艺科美课",
    releaseDate: "2026-03-10 09:30:00",
    createTime: "2026-03-10 09:30:00",
    content: buildNewsContent("全国高校工艺美术优秀作品征集持续进行中", [
      "平台将持续整理来自高校、机构与青年创作者的优秀作品，完善线上展示与报名信息。",
      "用户可通过官网活动页查看当前开放中的赛事活动，并跳转到现有报名入口。",
      "为了保证线上体验，官网资讯页当前采用稳定内容集与现有活动接口组合呈现。",
    ]),
  },
  {
    id: 103,
    classify: 1,
    title: "传统工艺数字化展示专题页面完成首轮更新",
    summary: "专家库、信息库与平台介绍页完成结构整理，支持在现有接口体系下稳定运行。",
    image: newsCover,
    source: "艺科美课",
    releaseDate: "2026-02-28 15:20:00",
    createTime: "2026-02-28 15:20:00",
    content: buildNewsContent("传统工艺数字化展示专题页面完成首轮更新", [
      "本轮更新重点清理了已下线的旧接口依赖，保留网站核心展示能力与报名链路。",
      "专家与信息库内容目前以内置资料集呈现，保证页面可访问、内容可阅读。",
      "后续如果线上恢复对应内容管理能力，可继续替换为动态接口。",
    ]),
  },
  {
    id: 201,
    classify: 2,
    title: "官网内容服务切换说明",
    summary: "官网旧资讯接口已停用，现阶段统一切换至当前后端可用接口与稳定内容源。",
    image: noticeCover,
    source: "艺科美课公告",
    releaseDate: "2026-03-25 12:00:00",
    createTime: "2026-03-25 12:00:00",
    content: buildNewsContent("官网内容服务切换说明", [
      "为了保证官网在当前后端版本下稳定运行，平台已移除对旧资讯接口的直接依赖。",
      "现阶段活动内容优先使用当前投票活动接口，资讯与专家资料使用站点内置内容源。",
      "如需恢复原资讯后台，请补齐对应后端接口后再切回动态模式。",
    ]),
  },
  {
    id: 202,
    classify: 2,
    title: "站点维护公告",
    summary: "近期将持续优化官网内容结构与报名跳转链路，维护期间核心功能不受影响。",
    image: noticeCover,
    source: "艺科美课公告",
    releaseDate: "2026-03-12 08:00:00",
    createTime: "2026-03-12 08:00:00",
    content: buildNewsContent("站点维护公告", [
      "维护期间官网首页、活动详情页和报名入口将保持可访问状态。",
      "部分历史栏目内容将以整理后的站点资料集形式展示，不影响用户阅读。",
      "如遇异常，可刷新页面后重试，或从活动页重新进入报名入口。",
    ]),
  },
  {
    id: 203,
    classify: 2,
    title: "专家与信息库内容更新节奏说明",
    summary: "专家库与信息库当前采用定期整理发布方式，确保公开内容稳定且结构统一。",
    image: noticeCover,
    source: "艺科美课公告",
    releaseDate: "2026-02-20 14:00:00",
    createTime: "2026-02-20 14:00:00",
    content: buildNewsContent("专家与信息库内容更新节奏说明", [
      "站点专家与信息库页面当前以精选资料集形式对外展示。",
      "内容将根据专题方向按批次维护，不再依赖已停用的旧内容接口。",
      "后续接入新的后台内容管理能力后，可恢复更加细粒度的动态更新。",
    ]),
  },
];

const expertProfiles = [
  {
    id: 301,
    classify: 0,
    fullName: "王安和",
    rank: "工艺美术学者",
    image: expertAvatar1,
    birthday: "1968-05-12",
    nation: "汉族",
    sex: "男",
    education: "研究生",
    titleGrade: "教授",
    occupation: "工艺美术研究与教学",
    direction: "传统工艺设计、工艺美术教育",
    userPosition: "院校课程顾问",
    schoolDictDto: { name: "工艺美术研究中心" },
    personalResume: [
      { year: "1998", content: "开始从事传统工艺理论研究与教学工作" },
      { year: "2010", content: "参与多所高校工艺美术课程体系建设" },
      { year: "2024", content: "参与平台公开课程与专题内容整理" },
    ],
    awardExperience: [
      { year: "2015", content: "工艺美术教育成果奖", address: "北京" },
      { year: "2021", content: "传统工艺创新推广奖", address: "上海" },
    ],
    academicContribution: [
      { year: "2018", content: "《工艺美术课程体系研究》", address: "艺术教育研究" },
      { year: "2023", content: "《传统工艺数字展示路径》", address: "工艺论坛" },
    ],
    publication: [
      { image: publicationCover, name: "工艺材料与纹样研究", content: "围绕材料、图样与工艺流程展开系统梳理。" },
    ],
  },
  {
    id: 302,
    classify: 0,
    fullName: "陈乐言",
    rank: "青年导师",
    image: expertAvatar2,
    birthday: "1982-09-03",
    nation: "汉族",
    sex: "女",
    education: "硕士",
    titleGrade: "副教授",
    occupation: "工艺设计教学",
    direction: "文化创意设计、课程转化",
    userPosition: "课程共建讲师",
    schoolDictDto: { name: "设计与工艺学院" },
    personalResume: [
      { year: "2009", content: "进入高校开展工艺设计教学" },
      { year: "2019", content: "参与校企共建课程设计项目" },
    ],
    awardExperience: [
      { year: "2020", content: "青年设计人才奖", address: "杭州" },
    ],
    academicContribution: [
      { year: "2022", content: "《传统手工艺课程转化实践》", address: "设计教育" },
    ],
    publication: [
      { image: publicationCover, name: "材料实验系列", content: "以课堂项目为基础形成的系列成果展示。" },
    ],
  },
  {
    id: 303,
    classify: 1,
    fullName: "刘承序",
    rank: "工美大师",
    image: expertAvatar3,
    birthday: "1961-11-28",
    nation: "汉族",
    sex: "男",
    education: "本科",
    titleGrade: "国家级工艺美术大师",
    occupation: "漆艺创作",
    direction: "传统漆艺与当代转化",
    userPosition: "行业导师",
    schoolDictDto: { name: "传统工艺研究院" },
    personalResume: [
      { year: "1992", content: "开始长期从事漆艺创作与传承工作" },
      { year: "2016", content: "参与多地非遗传承课程建设" },
    ],
    awardExperience: [
      { year: "2017", content: "中国工艺美术精品奖金奖", address: "福州" },
    ],
    academicContribution: [
      { year: "2021", content: "《漆艺语言的当代应用》", address: "工艺美术观察" },
    ],
    publication: [
      { image: publicationCover, name: "漆艺作品集", content: "展示传统髹饰技法与现代空间语言的结合。" },
    ],
  },
  {
    id: 304,
    classify: 1,
    fullName: "周以宁",
    rank: "工美大师",
    image: expertAvatar4,
    birthday: "1975-02-16",
    nation: "汉族",
    sex: "女",
    education: "本科",
    titleGrade: "省级工艺美术大师",
    occupation: "纤维艺术创作",
    direction: "纤维艺术、综合材料",
    userPosition: "专题导师",
    schoolDictDto: { name: "纤维艺术工作室" },
    personalResume: [
      { year: "2005", content: "成立纤维艺术专题工作室" },
      { year: "2022", content: "参与平台专题展陈内容策划" },
    ],
    awardExperience: [
      { year: "2019", content: "综合材料创新奖", address: "苏州" },
    ],
    academicContribution: [
      { year: "2024", content: "《纤维材料在公共艺术中的表达》", address: "公共艺术研究" },
    ],
    publication: [
      { image: publicationCover, name: "纤维与空间", content: "以系列装置作品回应传统工艺与空间叙事。" },
    ],
  },
  {
    id: 305,
    classify: 1,
    fullName: "孙知远",
    rank: "传承导师",
    image: expertAvatar5,
    birthday: "1970-07-05",
    nation: "汉族",
    sex: "男",
    education: "本科",
    titleGrade: "非遗传承人",
    occupation: "陶瓷工艺创作",
    direction: "陶瓷工艺、地方技艺传承",
    userPosition: "非遗实践导师",
    schoolDictDto: { name: "地方工艺传习中心" },
    personalResume: [
      { year: "1996", content: "长期开展陶瓷烧制与教学" },
      { year: "2020", content: "参与青年工艺人才培养项目" },
    ],
    awardExperience: [
      { year: "2018", content: "传统技艺传承奖", address: "景德镇" },
    ],
    academicContribution: [
      { year: "2023", content: "《陶瓷工艺的教学转化》", address: "非遗教育" },
    ],
    publication: [
      { image: publicationCover, name: "陶瓷创作纪要", content: "总结地方工艺材料与烧制经验。" },
    ],
  },
];

const infoBaseCategories = [
  { id: 1, name: "国家级工艺美术大师" },
  { id: 2, name: "非遗传承人" },
  { id: 3, name: "青年设计人才" },
];

const infoBaseProfiles = [
  {
    id: 401,
    categoryId: 1,
    fullName: "赵文澜",
    image: expertAvatar1,
    birthday: "1964-01-09",
    nation: "汉族",
    sex: "男",
    education: "本科",
    titleGrade: "国家级工艺美术大师",
    occupation: "雕塑创作",
    direction: "传统雕刻语言与公共空间",
    userPosition: "行业专家",
    schoolDictDto: { name: "工艺雕塑研究室" },
    personalResume: [
      { year: "1991", content: "从事工艺雕塑创作与研究" },
      { year: "2017", content: "参与传统技艺课程资源建设" },
    ],
    awardExperience: [
      { year: "2016", content: "中国工艺美术百花奖", address: "南京" },
    ],
    academicContribution: [
      { year: "2021", content: "《雕塑与工艺的当代接口》", address: "艺术创作研究" },
    ],
    publication: [
      { image: publicationCover, name: "雕塑语汇整理", content: "围绕传统雕塑语汇与当代表达的系统梳理。" },
    ],
  },
  {
    id: 402,
    categoryId: 1,
    fullName: "高舒宁",
    image: expertAvatar2,
    birthday: "1976-04-18",
    nation: "汉族",
    sex: "女",
    education: "硕士",
    titleGrade: "省级工艺美术大师",
    occupation: "首饰设计",
    direction: "金属工艺与首饰创新",
    userPosition: "设计导师",
    schoolDictDto: { name: "首饰与金工中心" },
    personalResume: [
      { year: "2008", content: "开始从事首饰设计与教学工作" },
      { year: "2023", content: "参与青年设计人才专题整理" },
    ],
    awardExperience: [
      { year: "2022", content: "金属工艺创新奖", address: "深圳" },
    ],
    academicContribution: [
      { year: "2024", content: "《金工语言的现代转译》", address: "设计周刊" },
    ],
    publication: [
      { image: publicationCover, name: "金工实验", content: "以系列作品呈现金属工艺与佩戴体验。" },
    ],
  },
  {
    id: 403,
    categoryId: 2,
    fullName: "吴南乔",
    image: expertAvatar3,
    birthday: "1971-10-22",
    nation: "汉族",
    sex: "女",
    education: "本科",
    titleGrade: "非遗传承人",
    occupation: "织绣技艺传承",
    direction: "地方织绣工艺",
    userPosition: "传承导师",
    schoolDictDto: { name: "非遗工坊" },
    personalResume: [
      { year: "2001", content: "开展地方织绣技艺保护与传播" },
      { year: "2020", content: "参与非遗工坊课程共建" },
    ],
    awardExperience: [
      { year: "2019", content: "非遗传承推广奖", address: "成都" },
    ],
    academicContribution: [
      { year: "2022", content: "《织绣技艺的校园转化》", address: "非遗论坛" },
    ],
    publication: [
      { image: publicationCover, name: "织绣图样集", content: "整理地方图样与织造经验形成的资料集。" },
    ],
  },
  {
    id: 404,
    categoryId: 2,
    fullName: "何立山",
    image: expertAvatar4,
    birthday: "1969-03-12",
    nation: "汉族",
    sex: "男",
    education: "本科",
    titleGrade: "非遗传承人",
    occupation: "木作工艺",
    direction: "传统木作与结构研究",
    userPosition: "工作坊导师",
    schoolDictDto: { name: "传统营造实验室" },
    personalResume: [
      { year: "1995", content: "从事木作工艺与结构研究" },
      { year: "2021", content: "参与平台专题实践课程整理" },
    ],
    awardExperience: [
      { year: "2018", content: "传统营造实践奖", address: "苏州" },
    ],
    academicContribution: [
      { year: "2023", content: "《木作结构课程化实践》", address: "建筑工艺研究" },
    ],
    publication: [
      { image: publicationCover, name: "木作样式记录", content: "记录传统木作构件与榫卯关系。" },
    ],
  },
  {
    id: 405,
    categoryId: 3,
    fullName: "蒋晴川",
    image: expertAvatar5,
    birthday: "1990-08-08",
    nation: "汉族",
    sex: "女",
    education: "硕士",
    titleGrade: "青年设计人才",
    occupation: "文创设计",
    direction: "工艺品牌与视觉系统",
    userPosition: "青年设计顾问",
    schoolDictDto: { name: "文化创意实验室" },
    personalResume: [
      { year: "2016", content: "进入文创设计领域开展项目实践" },
      { year: "2025", content: "参与官网专题内容重构" },
    ],
    awardExperience: [
      { year: "2024", content: "青年创意设计奖", address: "上海" },
    ],
    academicContribution: [
      { year: "2025", content: "《工艺品牌的数字传播》", address: "品牌设计观察" },
    ],
    publication: [
      { image: publicationCover, name: "文创视觉样本", content: "聚焦工艺内容在数字传播中的品牌化表达。" },
    ],
  },
];

const milestones = [
  {
    id: 1,
    year: 2014,
    title: "平台规划启动",
    description: "启动传统工艺美术在线教育与展示平台整体规划。",
    image: timelineCover1,
  },
  {
    id: 2,
    year: 2016,
    title: "课程体系搭建",
    description: "围绕工艺史论、设计方法与作品展示完成首轮课程框架。",
    image: timelineCover2,
  },
  {
    id: 3,
    year: 2019,
    title: "线上站点上线",
    description: "网站 1.0 版本上线，逐步开放课程、活动与公开展示板块。",
    image: timelineCover3,
  },
  {
    id: 4,
    year: 2021,
    title: "内容结构升级",
    description: "持续补充专家、信息库与平台介绍内容，强化专题化呈现。",
    image: timelineCover1,
  },
  {
    id: 5,
    year: 2023,
    title: "活动专题扩展",
    description: "在官网中接入更多活动展示能力，支持报名与成果展示链路。",
    image: timelineCover2,
  },
  {
    id: 6,
    year: 2026,
    title: "站点兼容改造",
    description: "清理旧接口依赖，切换到当前后端可稳定支持的官网能力。",
    image: timelineCover3,
  },
];

const fallbackBanners = {
  3: [{ id: 1, title: "专家智库", image: bannerExpert, area: 3 }],
  4: [{ id: 2, title: "信息库", image: bannerInfoBase, area: 4 }],
  5: [{ id: 3, title: "关于我们", image: bannerAbout, area: 5 }],
};

function serializeProfile(profile) {
  return {
    ...profile,
    personalResume: JSON.stringify(profile.personalResume || []),
    awardExperience: JSON.stringify(profile.awardExperience || []),
    academicContribution: JSON.stringify(profile.academicContribution || []),
    publication: JSON.stringify(profile.publication || []),
  };
}

export function getNewsList(classify = 1) {
  return newsRecords
    .filter((item) => item.classify === Number(classify))
    .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate));
}

export function getNewsDetail(id) {
  return newsRecords.find((item) => Number(item.id) === Number(id)) || newsRecords[0];
}

export function getNewsRecommendList(classify = 1, currentId) {
  return getNewsList(classify)
    .filter((item) => Number(item.id) !== Number(currentId))
    .slice(0, 6);
}

export function getNewsTypeList(classify = 1, currentId) {
  const list = getNewsRecommendList(classify, currentId);
  return {
    hot: list[0] || null,
    news: list[1] || null,
    related: list[2] || null,
  };
}

export function getMilestones() {
  return milestones;
}

export function getExpertList(classify = 0) {
  return expertProfiles.filter((item) => Number(item.classify) === Number(classify));
}

export function getExpertDetail(id) {
  const profile = expertProfiles.find((item) => Number(item.id) === Number(id)) || expertProfiles[0];
  return serializeProfile(profile);
}

export function getInfoBaseCategories() {
  return infoBaseCategories;
}

export function getInfoBaseList(params = {}) {
  const {
    page = 1,
    limit = 35,
    sortName = infoBaseCategories[0].id,
    keyword = "",
  } = params;

  const filtered = infoBaseProfiles.filter((item) => {
    const matchCategory = Number(item.categoryId) === Number(sortName);
    const matchKeyword = !keyword || item.fullName.includes(keyword);
    return matchCategory && matchKeyword;
  });

  const currentPage = Math.max(Number(page) || 1, 1);
  const pageSize = Math.max(Number(limit) || 35, 1);
  const start = (currentPage - 1) * pageSize;
  const data = filtered.slice(start, start + pageSize).map((item) => ({
    id: item.id,
    fullName: item.fullName,
  }));

  return createResult(data, {
    total: filtered.length,
    totalPage: Math.max(Math.ceil(filtered.length / pageSize), 1),
  });
}

export function getInfoBaseDetail(id) {
  const profile = infoBaseProfiles.find((item) => Number(item.id) === Number(id)) || infoBaseProfiles[0];
  return serializeProfile(profile);
}

export function getFallbackBannerList(area = 0) {
  return fallbackBanners[Number(area)] || [];
}

export function mapVoteActivity(activity = {}) {
  const startDate = formatDate(activity.startTime);
  const stopDate = formatDate(activity.endTime);
  const summary = stripHtml(activity.content).slice(0, 80);
  const browse = Number(activity.browse || 0);
  const expertVotes = Number(activity.expertVotes || 0);

  return {
    id: activity.id,
    title: activity.title || "活动详情",
    activityName: activity.title || "活动详情",
    image: activity.imgWeb || activity.banner || activity.image || activityCover,
    summary: summary || "当前活动详情由现有投票活动接口提供。",
    content: activity.content || "<p>当前活动暂无更多公开介绍。</p>",
    startDate,
    stopDate,
    createTime: startDate,
    releaseDate: startDate,
    sponsor: "艺科美课",
    site: activity.address || "线上展示",
    address: activity.address || "线上展示",
    price: 0,
    signUpNum: expertVotes,
    clickNum: browse,
    activityNum: browse,
    isEnd: !!stopDate && new Date(`${stopDate}T23:59:59`).getTime() < Date.now(),
  };
}

export function createStaticResult(data, extra = {}) {
  return createResult(data, extra);
}
